import EConsentContext from '@/contexts/EConsentContext';
import { FC, useContext } from 'react';
import OptionalConsentEConsentForm from './optional-consent/OptionalConsentEConsentForm';
import OptionalConsentStandardForm from './optional-consent/OptionalConsentStandardForm';

const OptionalConsentForm: FC = () => {
    const { userType } = useContext(EConsentContext);

    return userType
        ? <OptionalConsentEConsentForm />
        : <OptionalConsentStandardForm />;
};

export default OptionalConsentForm;
